<template>
    <b-button :variant="type" :block="block" :disabled="isDisabled" @click="$emit('click')">
        <b-spinner small v-if="loading"></b-spinner>
        <slot v-if="!loading" />
    </b-button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
            default: "primary"
        },
        block: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isDisabled() {
            return (this.loading == true || this.disabled == true);
        }
    }
}
</script>